/* @flow */
import React from 'react';
import OverlayLoading from 'components/OverlayLoading.jsx';

import './styles/IframePreview.scss';

type Props = {
  src: string,
  height: number,
};

type State = {
  loading: boolean,
};

class IframePreview extends React.Component {
  props: Props;
  state: State = {
    loading: true,
  };

  componentWillReceiveProps = (nextProps: Props) => {
    if (this.props.src !== nextProps.src) {
      this.setState({ loading: true });
    }
  }

  onLoad = () => this.setState({ loading: false });

  render() {
    return (
      <div className="IframePreview" style={{ height: this.props.height + 5 }}>
        {this.state.loading && <OverlayLoading />}
        <iframe
          onLoad={this.onLoad}
          src={this.props.src}
          style={{ width: '100%', height: this.props.height }}
        />
      </div>
    );
  }
}

export default IframePreview;



// WEBPACK FOOTER //
// ./src/components/IframePreview.jsx